import { io } from 'socket.io-client';
import jwt_decode from 'jwt-decode';

let socketAdmin = null;
let socketUser = null;
let infoUser = null;
let isInitialized = false;

const getSocketAdmin = () => socketAdmin;
const getSocketUser = () => socketUser;

const initializeSockets = () => {
  if (isInitialized) return;

  const token = localStorage.getItem('saxToken');
  infoUser = token ? jwt_decode(token) : null;

  const connectSockets = () => {
    if (document.visibilityState === 'visible') {
      if (!socketAdmin || !socketAdmin.connected) {
        socketAdmin = io(process.env.REACT_APP_BACKEND_ADMIN_URL, {
          transports: ['websocket'],
          autoConnect: true,
          reconnection: true,
        });

        socketAdmin.on('connect', () => {
          socketAdmin.emit('registerUser', infoUser?.id);
        });
      }

      if (!socketUser || !socketUser.connected) {
        socketUser = io(process.env.REACT_APP_BACKEND_URL, {
          transports: ['websocket'],
          autoConnect: true,
          reconnection: true,
        });

        socketUser.on('connect', () => {
          socketUser.emit('registerUser', infoUser?.id);
        });
      }
    }
  };

  const disconnectSockets = () => {
    if (socketAdmin) {
      socketAdmin.removeAllListeners();
      socketAdmin.disconnect();
    }
    if (socketUser) {
      socketUser.removeAllListeners();
      socketUser.disconnect();
    }
  };

  const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      connectSockets();
    } else {
      disconnectSockets();
    }
  };

  document.addEventListener('visibilitychange', handleVisibilityChange);
  connectSockets();

  isInitialized = true;

  return () => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    disconnectSockets();
    isInitialized = false;
  };
};

initializeSockets();

export { getSocketAdmin, getSocketUser, initializeSockets };